import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'currencyFix',
  standalone: true
})
export class CurrencyFixPipe implements PipeTransform {
  transform(value: number): number {
    return value / 100;
  }
}
